import { render, staticRenderFns } from "./KabMappi.vue?vue&type=template&id=0fb84393"
import script from "./KabMappi.vue?vue&type=script&lang=js"
export * from "./KabMappi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports